/**
 * Usage:
 * import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
 *
 * @param {String} elementId
 * @param {String} html
 * @returns {Element|null} Returns the DOM Element from elementId or null
 */
export function setElementHtml (elementId, html) {
  const element = document.getElementById(elementId)
  if (!element) return null

  element.innerHTML = html
  return element
}
